export let ExistingAccountActionTypes;
(function (ExistingAccountActionTypes) {
  ExistingAccountActionTypes["AccountsRequested"] = "[Existing Accounts] Requested";
  ExistingAccountActionTypes["AccountsFetched"] = "[Existing Accounts] Fetched";
  ExistingAccountActionTypes["AccountsFetchedFailed"] = "[Existing Accounts] Fetched Failed";
})(ExistingAccountActionTypes || (ExistingAccountActionTypes = {}));